import React, { useEffect, useState } from "react";
import { filesize } from "filesize";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import {
  FaCloudUploadAlt,
  FaCheckCircle,
  FaSpinner,
  FaTimesCircle,
  FaTimes,
} from "react-icons/fa";
import {
  useSelector,
  useDispatch,
  useLocation,
  useNavigate,
} from "../../components/hooks/hooks";
import { awsConfig } from "../../config";
import AWS from "aws-sdk";
import { BsArrowLeftCircleFill } from "react-icons/bs";
import { ToastContainer, toast } from "react-toastify";
import { backendApi } from "../../api/apiService";
import { setAwsConfigData } from "../../redux/reducers/masterDataSlice";
import LoaderImage from "../../images/spinner.gif";
export default function ResumeBulkUpload() {
  const dispatch = useDispatch()
  const nav = useNavigate();;
  const { awsData, recuitmentStatus } = useSelector(
    (state) => state.commonData
  );
  const locationProps = useLocation();
  const [awsConfigDataState, setAwsConfigDataState] = useState(awsConfig);
  const [skillsArray, setSkillsArray] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [processedFiles, setProcessedFiles] = useState([]);
  const [unValidFileProcessedFiles, setunValidFileProcessedFiles] = useState(
    []
  );
  const [flag, setFlag] = useState(false);
  var s3;
  useEffect(() => {
    setTimeout(() => {
      document.getElementById("ProcessingMenu").classList.add("active");
    }, 500);
  }, []);
  const handleFileUpload = (e) => {
    setSelectedFiles([]);
    setProcessedFiles([]);
    setunValidFileProcessedFiles([]);
    setFlag(false);
    const files = e.target.files;
    if (files.length > 20) {
      toast.warn("Only 20 Files Can Be Uploaded At A Time", {
        containerId: "D",
      });
      return;
    }
    const allowedFileTypes = [
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/pdf",
    ];
    const selectedFileLoad = [];
    const unValidFormat = [];

    for (const file of files) {
      if (allowedFileTypes.includes(file.type)) {
        selectedFileLoad.push(file);
      } else {
        unValidFormat.push(file);
      }
    }
    if (selectedFileLoad.length > 0) {
      setSelectedFiles(selectedFileLoad);
    }
    if (unValidFormat.length > 0) {
      setTimeout(() => {
        setunValidFileProcessedFiles([]);
      }, 4000);
      setunValidFileProcessedFiles(unValidFormat);
    }
  };
  const processResumeData = async () => {
    setFlag(true);
    let parsedData;
    const updatedSelectedFiles = selectedFiles.map((file) => {
      file.flagFile = "loading";
      return file;
    });
    setSelectedFiles(updatedSelectedFiles);
    if (selectedFiles) {
      try {
        for (const selectedFile of selectedFiles) {
          const bucketParams = {
            Bucket: awsConfigDataState.s3Bucket,
          };
          AWS.config.update({
            accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY,
            secretAccessKey: process.env.REACT_APP_S3_SECRET_KEY,
            region: "us-east-1",
          });
          const s3 = new AWS.S3({
            apiVersion: "2006-03-01",
            params: bucketParams,
          });
          const data = await s3
            .upload({
              Key: `${awsConfigDataState.s3BucketMainFolder}/${awsConfigDataState.s3BucketSubFolder}/${selectedFile.name}`,
              Body: selectedFile,
              ACL: "public-read",
            })
            .promise();
          await new Promise((resolve) => setTimeout(resolve, 5000));
          const prompt =
            "This is an extract of a resume find the name of the person,address,number,email,skills,total experience,gender if gender or sex is specified and date of birth from this text without code and prefix just in this format   {" +
            '"name":"",' +
            '"address":"",' +
            '"number":"",' +
            '"email":"",' +
            '"skills":["","",""],' +
            '"experience":"",' +
            '"gender":"",' +
            '"dob":""' +
            "} which can be json parsed and dont mind if there are no values for the above mentioned parameters just give me the object which can be json parsed ";

          let apiReq;
          if (data.Location.endsWith(".pdf")) {
            apiReq = {
              functionName: "pdfDataExtraction",
              file_url: `${data.Location}`,
            };
          } else {
            apiReq = {
              functionName: "wordDataExtraction",
              file_url: `${data.Location}`,
            };
          }
          const fileData = await backendApi(apiReq);

          if (fileData.success === "1") {
            if (fileData.textContent != "\n\n") {
              const req = {
                functionName: "chatGpt_openai",
                prompt: `${fileData.textContent}+${prompt}`,
              };
              const gptData = await backendApi(req);
              if (gptData.success === "1") {
                if (
                  gptData.data.choices[0].message.content
                    .trim()
                    .toLowerCase()
                    .startsWith("answer:")
                ) {
                  const jsonStartIndex =
                    gptData.data.choices[0].message.content.indexOf("{");
                  const jsonString =
                    gptData.data.choices[0].message.content.substring(
                      jsonStartIndex
                    );

                  try {
                    parsedData = JSON.parse(jsonString);
                  } catch (error) {
                    console.error("Error parsing JSON:", error);
                  }
                } else {
                  try {
                    parsedData = JSON.parse(
                      gptData.data.choices[0].message.content
                    );
                  } catch (error) {
                    console.error("Error parsing JSON:", error);
                    failedCondition(selectedFile.name);
                  }
                }
                const saveFormResult = await saveForm(
                  parsedData,
                  selectedFile,
                  `${data.Location}`,
                  fileData.textContent
                );
              } else {
                failedCondition(selectedFile.name);
              }
              setLoading(false);
              document.body.classList.remove("overflow-hidden");
            } else {
              setLoading(false);
              failedCondition(selectedFile.name);
              document.body.classList.remove("overflow-hidden");
            }
          }
        }
      } catch (err) {
        console.error("err", err);
        return;
      }
    }
  };

  useEffect(() => {
    if (awsConfigDataState) {
      if (awsData !== "default") dispatch(setAwsConfigData(awsConfigDataState));
      const bucketParams = {
        Bucket: awsConfigDataState.s3Bucket,
      };
      AWS.config.update({
        accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY,
        secretAccessKey: process.env.REACT_APP_S3_SECRET_KEY,
        region: "us-east-1",
      });
      s3 = new AWS.S3({
        apiVersion: "2006-03-01",
        params: bucketParams,
      });
    }
  }, []);
  const saveForm = async (parsedData, selectedFile, location, textContent) => {
    setProcessedFiles((prevProcessedFiles) => [
      ...prevProcessedFiles,
      selectedFile.name,
    ]);
    let filteredSkills = skillsArray
      .filter((obj) => obj.checked == true)
      .map((obj) => ({
        skill_id: obj.id,
        rating: obj.starValue,
        experience: obj.experience,
      }));
    let noticePeriod = "";
    const apiSave = {
      functionName: "candidateSave",
      site_id: window.localStorage.getItem("siteId"),
      full_name: parsedData.name,
      email_id: parsedData.email,
      mobile_no: parsedData.number,
      sec_contact_no: "",
      total_experiance: parsedData.experience,
      ctc: "",
      ectc: "",
      location: "",
      preferredLocation: "",
      relocate: "",
      notice_period: "",
      remarks: "",
      status: "",
      created_by: localStorage.getItem("userId"),
      address: parsedData.address,
      resume_url: location,
      resume_text: textContent,
      skillSet: parsedData.skills,
      job_opening_id: locationProps.state.opening.id,
    };
    backendApi(apiSave).then((data) => {
      if (data.success === "1") {
        const updatedSelectedFiles = selectedFiles.map((file) => {
          if (file.name === selectedFile.name) {
            file.flagFile = true;
          }
          return file;
        });
        setSelectedFiles(updatedSelectedFiles);
        return data.success;
      } else {
        return selectedFile;
      }
    });
  };
  const removeResume = (data) => {
    const updatedFiles = selectedFiles.filter((file) => file !== data);
    setSelectedFiles(updatedFiles);
  };
  const failedCondition = (selectedFile) => {
    const updatedSelectedFiles = selectedFiles.map((file) => {
      if (file.name === selectedFile) {
        file.flagFile = false;
      }
      return file;
    });

    setSelectedFiles(updatedSelectedFiles);
  };
  const goBackButton = () => {
    nav('/assignRecruiter', { state: { props: locationProps.state.parameter } });
  }
 
  return (
    <>
      <div className="main-wrapper">
        <div className="top-color"></div>
        {/* <Header /> */}
        <div className="xilliContent">
          <ToastContainer
            enableMultiContainer
            containerId={"D"}
            position="bottom-right"
            autoClose={1500}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
          <LeftMenu />
          <div className="content-wrapper">
            <Header Header="Matching Resumes" />
            <div className="main-container">
              <div className="card main-card">
                <div className="card-body">
                  {loading && (
                    <div className="loader-div">
                      <img src={LoaderImage} alt="Loader" className="loader" />
                    </div>
                  )}
                  <div className="xilliBrudcrb">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row">
                            <h1 style={{
                              fontSize: "19px"
                            }}>
                              Upload resume(s) for Opening:{" "}
                              <span
                                onClick={goBackButton}
                                style={{
                                  textDecoration: "underline", color: "green", fontSize: "15px"
                                }}
                              >
                                {locationProps.state.opening.summary}
                              </span>
                            </h1>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="fileUpload">
                    <label className="label " style={{ width: "100%" }}>
                      <div className="upload-files-container">
                        <div className="drag-file-area">
                          <span className="material-icons-outlined upload-icon">
                            <FaCloudUploadAlt />
                          </span>
                          <h3 className="dynamic-message"> Upload your resume here </h3>
                          <span className="reBrowse">
                            <label className="label">
                              <span className="browse-files">
                                <input
                                  type="file"
                                  multiple
                                  className="default-file-input"
                                  onChange={(e) => {
                                    handleFileUpload(e);
                                    e.target.value = null;
                                  }}
                                />
                                <span className="browse-files-text"> browse file</span>{" "}
                                <span>from device</span>{" "}
                              </span>
                            </label>
                          </span>
                        </div>
                        <span className="cannot-upload-message">
                          {" "}
                          <span className="material-icons-outlined">error</span> Please
                          select a file first{" "}
                          <span className="material-icons-outlined cancel-alert-button">
                            cancel
                          </span>{" "}
                        </span>
                      </div>
                    </label>
                  </div>
                  {selectedFiles.length > 0 ||
                    unValidFileProcessedFiles.length > 0 ? (
                    <div className="col-md-12 xilliBrudcrb">
                      <h1 style={{
                        fontSize: "18px"
                      }}>Resume - {selectedFiles?.length}</h1>
                      <div className="table-responsive ">
                        <table className="table table-bordered">
                          <tbody>
                            <tr >
                              {selectedFiles.map((data, index) => (

                                <td className="bulk-resumeupload" key={index}>
                                  <span>
                                    <span className="file-size">{data.name}</span>
                                    {!processedFiles?.length > 0 && (
                                      <FaTimes onClick={() => removeResume(data)} />
                                    )}
                                  </span>
                                  <span>
                                    {data?.flagFile == true && (
                                      <span style={{ fontSize: "14px" }}>
                                        <FaCheckCircle color="green" />
                                      </span>
                                    )}
                                    {data?.flagFile == "loading" && flag ? (
                                      <span style={{ fontSize: "14px" }}>
                                        <FaSpinner
                                          color="blue"
                                          className="spinner-animation"
                                        />
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                    {data?.flagFile === false && flag ? (
                                      <span style={{ fontSize: "14px" }}>
                                        <FaTimesCircle color="red" />
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </span>
                                </td>

                              ))}
                            </tr>
                            <tr>
                              {unValidFileProcessedFiles.length > 0 &&
                                unValidFileProcessedFiles.map((data, index) => (

                                  <td className="bulk-resumeupload" key={index}>
                                    <span>
                                      <span className="file-size">{data.name}</span>
                                      -
                                      <span
                                        style={{ fontSize: "14px", color: "red" }}
                                      >
                                        Invalid Format
                                      </span>
                                    </span>
                                  </td>


                                ))}
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      {selectedFiles.length > 0 && (
                        <div className="childIssueses">
                          {!flag ? (
                            <button
                              type="button"
                              className="btn-btn btn btn-btn2 btn-sm me-2"
                              onClick={() => processResumeData()}
                              style={{ fontSize: "14px" }}
                            >
                              {" "}
                              Upload{" "}
                            </button>
                          ) : (
                            ""
                          )}
                          <button
                            type="button"
                            className="btn-btn btn btn-btn1 btn-sm "
                            onClick={() => {
                              setSelectedFiles([]);
                              setunValidFileProcessedFiles([]);
                            }}
                            style={{ fontSize: "14px" }}
                          >
                            {" "}
                            Reset{" "}
                          </button>
                        </div>
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <button
              type="button"
              className="floating-back-button"
              onClick={goBackButton}
            >
              <BsArrowLeftCircleFill size={24}/>
            </button>
          </div>
        </div>
      </div>

    </>
  );
}
